import styled from 'styled-components';

export const ModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 520px;
  max-height: 78vh;
`;

export const ModalBodyRow = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  border-top: 1px solid rgba(21, 43, 78, 0.08);
`;

export const ChecklistPanel = styled.aside`
  width: 300px;
  flex-shrink: 0;
  border-right: 1px solid rgba(21, 43, 78, 0.08);
  padding: 16px 12px;
  overflow-y: auto;
  background: #f8fafc;
`;

export const ChecklistTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.04em;
  margin-bottom: 12px;
`;

export const ChecklistItem = styled.button`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid ${({ active }) => (active ? '#1d4ed8' : 'rgba(21, 43, 78, 0.1)')};
  border-radius: 10px;
  background: ${({ active }) => (active ? '#eff6ff' : '#fff')};
  cursor: pointer;
  text-align: left;
  box-shadow: ${({ active }) => (active ? '0 0 0 1px #1d4ed8' : 'none')};

  &:hover {
    border-color: #1d4ed8;
  }
`;

export const ChecklistIcon = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
  color: ${({ done }) => (done ? '#fff' : '#94a3b8')};
  background: ${({ done }) => (done ? '#16a34a' : '#e2e8f0')};
`;

export const ChecklistText = styled.div`
  flex: 1;
`;

export const ChecklistLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #152b4e;
`;

export const ChecklistBadge = styled.span`
  display: inline-block;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: ${({ pending }) => (pending ? '#0369a1' : '#64748b')};
  background: ${({ pending }) => (pending ? '#e0f2fe' : '#f1f5f9')};
`;

export const PreviewPanel = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 16px 20px;
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const PreviewTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
`;

export const PreviewVersionBadge = styled.span`
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1d4ed8;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
`;

export const PreviewTitle = styled.h4`
  margin: 0;
  font-size: 15px;
  color: #152b4e;
  font-weight: 700;
  min-width: 0;
`;

export const PreviewToolbar = styled.div`
  display: flex;
  gap: 8px;
`;

export const ToolbarButton = styled.button`
  border: 1px solid rgba(21, 43, 78, 0.12);
  background: #fff;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  color: #334155;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PreviewFrame = styled.div`
  flex: 1;
  min-height: 320px;
  border: 1px solid rgba(21, 43, 78, 0.1);
  border-radius: 12px;
  background: #f1f5f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: auto;
  position: relative;
`;

export const PreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  padding: 12px;
  box-sizing: border-box;
`;

export const PreviewImageWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 200px;
`;

export const PreviewLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(241, 245, 249, 0.94);
  color: #64748b;
  font-size: 13px;
  z-index: 1;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: calc(78vh - 280px);
  object-fit: contain;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  transition: opacity 0.15s ease;
`;

export const PreviewEmpty = styled.div`
  color: #64748b;
  font-size: 14px;
  text-align: center;
  padding: 24px;
`;

export const PageDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 12px;
`;

export const PageDot = styled.button`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  padding: 0;
  background: ${({ active }) => (active ? '#1d4ed8' : '#cbd5e1')};
  cursor: pointer;
`;

export const HistoricoSection = styled.div`
  margin-top: 14px;
  border-top: 1px solid rgba(21, 43, 78, 0.08);
  padding-top: 12px;
`;

export const HistoricoTitle = styled.button`
  background: none;
  border: none;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
`;

export const HistoricoList = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HistoricoItem = styled.button`
  width: 100%;
  text-align: left;
  border: 1px solid rgba(21, 43, 78, 0.1);
  border-radius: 8px;
  padding: 10px 12px;
  background: ${({ active }) => (active ? '#eff6ff' : '#fff')};
  cursor: pointer;
  font-size: 12px;
  color: #334155;
`;

export const LoadingWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: #64748b;
`;

export const ErrorText = styled.div`
  color: #dc2626;
  padding: 24px;
  text-align: center;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;
